import { Box, FormControl, Slider, Typography } from '@mui/material'
import React, { useState } from 'react'

export type ConfidenceInterval = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

interface Props {
  onAnswerSelection: (confidence: ConfidenceInterval) => void
}

const OverallConfidenceQuestion = (props: Props) => {
  const [showSliderValue, setShowSliderValue] = useState(false)

  const marks = [
    {
      label: 'I have no confidence',
      value: 1
    },
    {
      label: 'I am certain',
      value: 10
    }
  ]

  return (
    <Box sx={{
      backgroundColor: 'white',
      maxWidth: '1200px',
      padding: '24px',
      width: '100%',
      margin: '24px auto'
    }}>
      <Typography variant='h2'>
        How confident are you in the overall commercial success of this startup?
      </Typography>
      <Box sx={{ m: 2, marginBottom: '48px', marginTop: '48px' }}>
        <FormControl sx={{
          width: '100%'
        }}>
          <Slider 
            marks={marks} 
            step={1}
            min={1}
            max={10}
            defaultValue={5}
            onChange={(event, value) => {
              setShowSliderValue(true)
              props.onAnswerSelection(value as ConfidenceInterval)
            }}
            sx={{
              width: '80%',
              margin: '12px auto 24px auto',
              '& .MuiSlider-thumb': {
                display: showSliderValue ? 'default' : 'none'
              },
              '& .MuiSlider-track': {
                display: showSliderValue ? 'default' : 'none'
              },
              '& .MuiSlider-markLabel': {
                fontSize: 14,
                color: '#09183D'
              }
            }}
          />
        </FormControl>
      </Box>
    </Box>
  )
}

export default OverallConfidenceQuestion
